async function get(url, options = {}) {
  try {
    let res = await fetch(url, options)
    if (res.ok === true && res.status === 200) {
      //see if returning json or not
      var response = await res.text()
      try {
        return JSON.parse(response)
      } catch (e) {
        return response
      }
    } else {
      var errRes = await res.json()
      if (!errRes) {
        errRes = res
      }
      return Promise.reject(errRes)
    }
  } catch (error) {
    console.log('Fetch - Get Error', error)
  }
}

async function post(
  url,
  data,
  headers = {
    'Content-Type': 'application/json',
  }
) {
  try {
    let res = await fetch(url, {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify(data),
    })

    if (res.ok === true && res.status === 200) {
      //see if returning json or not
      var response = await res.text()
      try {
        return JSON.parse(response)
      } catch (e) {
        return response
      }
    } else {
      var errRes = await res.json()
      if (!errRes) {
        errRes = res
      }
      return Promise.reject(errRes)
    }
  } catch (error) {
    console.log('Fetch - Post Error: ', error)
  }
}
export { get, post }
